module.exports = __webpack_public_path__ + "img/tu-1_05.9a65fb0b.jpg";